module.exports = __webpack_public_path__ + "img/scx.e909806e.png";